/**
 * Sorts booleans, treating undefined as false.
 * @param a first boolean
 * @param b second boolean
 * @returns negative number if a < b, positive if a > b, zero if equal
 */
export const booleanSorter = (a: boolean | undefined, b: boolean | undefined): number =>
  (a ? 1 : 0) - (b ? 1 : 0);

/**
 * Sort text using localeCompare() method.
 * @param a first string
 * @param b second string
 * @returns negative number if a < b, positive if a > b, zero if equal
 */
export const stringSorter = <T extends string>(a: T, b: T): number => {
  return a.localeCompare(b);
};
